const dataLayerHandler = (event, value, formLocation) => {
  if (typeof window.dataLayer !== 'undefined') {
    const params = (typeof value !== 'object' && typeof value !== 'function')
      ? {
        event: event,
        value: value ? value : '',
      }
      : {
        event: event,
        ...value
      }
    if (formLocation) {
      params.formLocation = formLocation;
    }
    window.dataLayer.push(params);
  }
}

export default dataLayerHandler;
